import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerExtractImporterRequest = {
	triggerFilters?: string[]
}

export const triggerExtractImporter = createAppAsyncThunk<void, TriggerExtractImporterRequest>(
	"formStep/triggerExtractImporter",
	async ({ triggerFilters }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			const { awToken } = getState().auth;

			if (!selectedEtlImportUuid || !awToken) return;

			await extra.etlClient.trigger(EtlApiTarget.LOAD_EXTRACT_IMPORTERS_API, selectedEtlImportUuid, { triggerFilters, args: { awToken } })
			dispatch(postToast({ message: "Données extraites avec succès", type: ToastType.SUCCESS }))


		} catch (error: any) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.preProcessRunning) return false;
		}
	}
);
